// src/components/Aurus.jsx
import React, { useRef } from "react";
import Slider from "react-slick";
import '../../css/aurus.scss'; 
import topBannerImg from '../../assets/img/Aurus/hero/1.jpg';



const Aurus = () => {
    const sliderRef = useRef(null);
  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    dots: true,
    autoplaySpeed: 6000,
    arrows: false,  // **Отключаем стандартные стрелки slick**
  };

  return (
    <div>
      <section className="hero js-hero-slider">
         <Slider ref={sliderRef} {...settings}>
          <div className="hero__item hero__item_animate-hover">
            <img src={topBannerImg} alt="" className="hero__img" />
            <div className="hero__block">
              <div className="wrapper">
                <div className="hero__left">
                  <div className="hero__subtitle">За пределами привычного</div>
                  <div className="hero__text">
                    Фундаментальные основы и новые подходы к созданию микроклимата.
                  </div>
                </div>
                <div className="hero__title">Климатическая техника</div>
              </div>
            </div>
          </div>

          <div className="hero__item hero__item_animate-hover">
            <img src={topBannerImg} alt="" className="hero__img" />
            <div className="hero__block">
              <div className="wrapper">
                <div className="hero__left">
                  <div className="hero__subtitle">За пределами привычного</div>
                  <div className="hero__text">
                    Фундаментальные основы и новые подходы к созданию микроклимата.
                  </div>
                </div>
                <div className="hero__title">Климатическая техника</div>
              </div>
            </div>
          </div>
        </Slider>
                {/* Кастомные стрелки */}
        <button
          className="slick-arrow slick-prev"
          onClick={() => sliderRef.current.slickPrev()}
          aria-label="Previous"
          type="button"
        />
        <button
          className="slick-arrow slick-next"
          onClick={() => sliderRef.current.slickNext()}
          aria-label="Next"
          type="button"
        />
      </section>
    </div>
  );
};

export default Aurus;
